import { ExternalLink } from "lucide-react";

// One-click deep link from a Colab record to HubSpot. The URL is built
// server-side (apps/api/src/services/hubspot-urls.ts) and surfaced on
// detail responses — the SPA has no access to HUBSPOT_PORTAL_ID and the
// custom-object type ID, so the worker resolves them.
//
// Pass `href` directly. The `label` defaults to "View in HubSpot"; callers
// can override to "View deal in HubSpot" / "View company in HubSpot" etc.
export function HubspotLink({
  href,
  label = "View in HubSpot",
  size = "md",
}: {
  href: string;
  label?: string;
  size?: "sm" | "md";
}) {
  const sizeClasses =
    size === "sm"
      ? "px-2 py-1 text-[10px] gap-1"
      : "px-2.5 py-1.5 text-xs gap-1.5";

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      className={`inline-flex items-center rounded-md border border-border bg-background font-medium text-foreground transition hover:bg-muted ${sizeClasses}`}
    >
      <ExternalLink className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {label}
    </a>
  );
}
